import { render, staticRenderFns } from "./report-results.vue?vue&type=template&id=000a9294&"
import script from "./report-results.vue?vue&type=script&lang=ts&"
export * from "./report-results.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports